module.exports = __webpack_public_path__ + "img/icon-listen.569247c3.gif";